import React from 'react';
import PropTypes from 'prop-types';
import styled from 'styled-components';
import CharsRemainingTextArea from './CharsRemainingTextArea'
import HelpBlock from "./HelpBlock";
import classNames from 'classnames';

const Question = styled('div')`
  padding-bottom: 1em;
  
  & .title {
    font-weight: bold
  }
  
  & input {
    width: 100%;
  }         
  `;

const TextAreaQuestion = ({question, value, onChange, error, disabled}) => {
  
  const titleClasses = classNames(
    'title',
    {'has-error': error}
  );

  return (
    <Question>
      <div className={titleClasses}>{question}</div>
      <CharsRemainingTextArea
        className="form-control"
        value={value}
        onChange={e => {
          onChange(e.currentTarget.value);
        } }
        maxLength={2000}
        disabled={disabled} />
      {error && (<HelpBlock type="error" />)}
    </Question>
  );
};

TextAreaQuestion.propTypes = {
  question: PropTypes.string.isRequired,
  value: PropTypes.string,
  error: PropTypes.bool,
  onChange: PropTypes.func.isRequired,
  disabled: PropTypes.bool
};

export default TextAreaQuestion;



// WEBPACK FOOTER //
// ./src/components/forms/TextAreaQuestion.js